export default "__VITE_ASSET__16dbd5ab__"